<!--
 * @Author: DY
 * @Date: 2024-12-03 14:26:17
 * @LastEditTime: 2026-06-01 11:48:13
 * @Description: 调拨入库明细表单
 * @FilePath: \ShiMo_Mobile\src\views\storage\allocationWarehouseEntryConfirm\form.vue
-->
<template>
    <v-touch @swiperight="swiperright" class="wrapper">
        <div class="allocationWarehouseEntryConfirmForm commonFormStyles">
            <HeaderNav
                header-title="调拨入库明细"
                v-if="!isNews"
                left-icon-name="2"
                right-icon-name="3"
                :extr="{ leftCallBack: swiperright }"
            ></HeaderNav>
            <div class="formList">
                <ul class="formItem" v-for="(item, index) in outboundDetails.detailInList" :key="`outboundDetails_${index}`">
                    <li class="formItemTitle">
                        <h5>物料代码: {{ item.MaterialCode }}</h5>
                    </li>
                    <li>
                        <van-cell
                            title="短描述"
                            :value="item.MaterialShortName"
                            :icon="require('@/assets/images/icons/icon_28@2x.png')"
                        ></van-cell>
                    </li>
                    <li>
                        <van-cell
                            title="计量单位"
                            :value="item.Unit"
                            :icon="require('@/assets/images/icons/icon_2@2x.png')"
                        ></van-cell>
                    </li>
                    <li>
                        <van-cell
                            title="调拨数量"
                            :value="item.VolumeTransfer"
                            :icon="require('@/assets/images/icons/icon_6@2x.png')"
                        ></van-cell>
                    </li>
                    <li class="materialItem" v-for="(k, j) in item.GridDetails" :key="`warehouseLocation_${j}`">
                        <van-cell :icon="require('@/assets/images/icons/icon_3@2x.png')">
                            <template #title>
                                <span class="custom-title">库位名称</span>
                                <button type="button" class="vanCellBtn" v-if="!isDisabled" @click="splitClick(item.GridDetails)">
                                    拆分
                                </button>
                                <button type="button" class="vanCellBtn" v-if="!isDisabled && k.showDeleteBtn" @click="deleteClick(item.GridDetails, j)">
                                    删除
                                </button>
                            </template>
                            <template #default>
                                <span class="custom-title" @click="selectWarehouseLocation(item, k)">{{ k.GridName }}</span>
                            </template>
                            <template #right-icon v-if="!isDisabled">
                                <button type="button" class="vanCellBtn" @click="selectWarehouseLocation(item, k)">
                                    选择库位
                                </button>
                            </template>
                        </van-cell>
                        <ol>
                            <li>
                                <h4>入库前库存：</h4>
                                <input type="text" disabled v-model="k.InBeforeVolume">
                            </li>
                            <li>
                                <h4>入库数量：</h4>
                                <input
                                    type="text"
                                    v-model="k.InVolume"
                                    :disabled="isDisabled"
                                    @change="inputInboundQuantity(item, k)"
                                >
                            </li>
                            <li>
                                <h4>入库后库存：</h4>
                                <input type="text" disabled v-model="k.InAfterVolume">
                            </li>
                        </ol>
                    </li>
                </ul>
            </div>
            <footer class="currencyFooterStyle">
                <template v-if="!isDisabled">
                    <button class="confirm" @click="submitForm">
                        提交
                    </button>
                    <button class="confirm" @click="saveForm">
                        保存
                    </button>
                </template>
                <template v-if="!isNews">
                    <button class="confirm" @click="closeAllocationForm">
                        关闭
                    </button>
                </template>
            </footer>
        </div>
    </v-touch>
</template>

<script>
import { mixin_MessageJump } from '@/assets/mixin/mixin_MessageJump';
import { HeaderNav } from '@/components/';
import NP from 'number-precision';
NP.enableBoundaryChecking(false);
export default {
    // 库位表单
    name: 'allocation-warehouse-entry-confirm-form',
    beforeRouteLeave(to, from, next) {
        if (to.path === '/allocationWarehouseEntryConfirm') {
            this.$store.commit('noKeepAlive', 'allocation-warehouse-entry-confirm-form');
        }
        next();
    },
    components: {
        HeaderNav,
    },
    mixins: [mixin_MessageJump],
    props: {},
    data() {
        return {
            isDisabled: false,
            outboundDetails: {},
            ID: '',
            Status: '',
            selectGridDetails: [],
            selectStorageLocationData: {},
            isNews: false,
        };
    },
    computed: {},
    watch: {},
    activated() {
        if (this.$route.params.WarehouseLocation) {
            const grid_code = this.$route.params.WarehouseLocation[0].grid_code;
            const res = this.selectGridDetails.filter(item => item.GridCode === grid_code);
            if (res.length === 0) {
                this.selectStorageLocationData.GridId = this.$route.params.WarehouseLocation[0].grid_id;
                this.selectStorageLocationData.GridCode = this.$route.params.WarehouseLocation[0].grid_code;
                this.selectStorageLocationData.GridName = this.$route.params.WarehouseLocation[0].grid_name;
                this.selectStorageLocationData.InBeforeVolume = this.$route.params.WarehouseLocation[0].volume;
            } else {
                this.$toast.fail('库位已存在，请重新选择！');
            }
        }
    },
    created() {
        this.initpage();
    },
    mounted() {},
    destroyed() {},
    methods: {
        // 右划回退
        swiperright() {
            this.$router.isBack = 1;
            this.$router.go(-1);
        },

        async initpage() {
            this.isNews = this.$route.params.isNews;
            if (this.isNews && this.$route.params.data.tenant_id) {
                // 有tenant_id，消息列表跳转办理页面，判断多租户
                await this.getNewsToken(this.$route.params.data.tenant_id);
            }
            this.ID = this.$route.params.data.Id;
            this.outboundDetails = await this.getWarehouseEntry(this.ID);
            this.Status = this.outboundDetails.status;
            if (this.Status !== 2) {
                this.isDisabled = true;
            }
        },

        splitClick(GridDetails) {
            GridDetails.push({
                GridId: '',
                GridCode: '',
                GridName: '',
                InBeforeVolume: '',
                InVolume: '',
                InAfterVolume: '',
                showDeleteBtn: true,
            });
        },

        deleteClick(GridDetails, index) {
            GridDetails.splice(index, 1);
        },

        // 选择库位
        selectWarehouseLocation(item, k) {
            if (this.isDisabled) { return; }
            this.selectGridDetails = item.GridDetails;
            this.selectStorageLocationData = k;
            this.$router.isBack = 2;
            this.$router.replace({
                name: 'selectListView',
                params: {
                    newsToken: this.newsToken,
                    pageTitle: '选择库位',
                    sourcePath: 'allocationWarehouseEntryConfirmForm',
                    listCode: 'choose_grid_only',
                    callbackDataKey: 'WarehouseLocation',
                    requestUrl: `/basicplatform/tabledata?stock_id=${item.InStockId}&material_code=${item.MaterialCode}`,
                    relationKey: 'grid_id',
                    indexKey: 'page',
                    sizeKey: 'limit',
                    headerList: [{
                        name: '库位编号',
                        code: 'grid_code',
                        isTitle: true,
                    }, {
                        name: '库位名称',
                        code: 'grid_name',
                        icon: 'icon_44@2x',
                    }, {
                        name: '库位类别',
                        code: 'grid_category_name',
                        icon: 'icon_13@2x',
                    }, {
                        name: '当前库存',
                        code: 'before_volume',
                        icon: 'icon_16@2x',
                    }, {
                        name: '存放最大量',
                        code: 'volume_max',
                        icon: 'icon_16@2x',
                    }, {
                        name: '实时库存',
                        code: 'volume',
                        icon: 'icon_16@2x',
                    }],
                },
            });
        },

        inputInboundQuantity(item, k) {
            let nubs = 0;
            item.GridDetails.forEach(z => {
                nubs = NP.plus(nubs, z.InVolume);
            });
            if (nubs > item.VolumeTransfer) {
                this.$toast.fail('出库数量大于调拨数量，请重新输入！');
                this.$nextTick(() => {
                    this.$set(k, 'InVolume', 0);
                    this.$set(k, 'InAfterVolume', NP.plus(k.InBeforeVolume || 0, k.InVolume || 0));
                });
            } else {
                this.$set(k, 'InAfterVolume', NP.plus(k.InBeforeVolume || 0, k.InVolume || 0));
            }
        },

        async saveForm() {
            const res = await this.saveFormRequest(this.ID, this.outboundDetails.detailInList);
            if (res) {
                this.$toast.success('保存成功。');
            }
        },

        async submitForm() {
            const res = await this.submitFormRequest(this.ID);
            if (res) {
                this.$toast.success('提交成功。');
                this.closeAllocationForm();
            }
        },

        closeAllocationForm() {
            if (!this.isNews) {
                this.$router.isBack = 1;
                this.$router.replace({
                    name: 'allocationWarehouseEntryConfirm',
                    params: {
                        saveCallback: true,
                    },
                });
            } else {
                this.isDisabled = true;
            }
        },

        getWarehouseEntry(id) {
            return this.$axios.$get(`/interfaceApi/procurement/stock_transfer/get_details_in/${id}`, { token: this.newsToken });
        },
        saveFormRequest(transferId, requestData) {
            return this.$axios.$post(`/interfaceApi/procurement/stock_transfer/details_in_save/${transferId}`, requestData, { token: this.newsToken });
        },
        submitFormRequest(transferId) {
            return this.$axios.$put(`/interfaceApi/procurement/stock_transfer/in_submit/${transferId}`, {}, { token: this.newsToken });
        },
    },
};
</script>
<style lang="stylus">
.allocationWarehouseEntryConfirmForm
    background #F0F0F0
    .formList
        padding 10rpx
        li
            &.materialItem
                border-bottom: 1px solid #f0f0f0
                .van-cell
                    border none
                ol
                    display: flex
                    padding 5rpx 7rpx 14rpx 7rpx
                    background: #fff
                    li
                        flex 1
                        padding: 0 7rpx
                        h4
                            font-size 14rpx
                            color #626262
                            margin-bottom: 7rpx
                        input
                            width 100%
                            height 36rpx
                            border 1px solid #D7D7D7
                            border-radius: 4rpx
                            font-size 12rpx
                            padding: 0 10rpx
</style>
